'use client';

import { useMutation } from '@tanstack/react-query';
import { requestPasswordReset } from '@/lib/api/auth/request-password-reset';

export function useRequestPasswordReset() {
  return useMutation({ mutationFn: requestPasswordReset });
}
